export const SLIDE_ACCENT: Record<string, string> = {
  single_choice: '#0085ff',
  multiple_choice: '#1d9bf0',
  true_false: '#22c55e',
  matching: '#a855f7',
  ordering: '#ec4899',
  image_choice: '#14b8a6',
  accordion: '#0ea5e9',
  drag_words: '#6366f1',
  fill_blank: '#d97706',
  fill_blanks: '#d97706',
  find_words: '#10b981',
  mark_words: '#f97316',
  complex_fill_blank: '#8b5cf6',
  content: '#6b8299',
  video: '#ffffff',
}

export const CONTENT_KIND_ACCENT: Record<string, string> = {
  text: '#6b8299',
  quote: '#0ea5e9',
  callout: '#f59e0b',
  caption: '#14b8a6',
  table: '#22c55e',
  formula: '#8b5cf6',
}

export const SLIDE_FEATHER_ICON: Record<string, string> = {
  single_choice: 'check-circle',
  multiple_choice: 'check-square',
  true_false: 'toggle-left',
  matching: 'link',
  ordering: 'list',
  image_choice: 'image',
  accordion: 'layers',
  drag_words: 'move',
  fill_blank: 'edit-3',
  fill_blanks: 'edit-2',
  find_words: 'search',
  mark_words: 'type',
  complex_fill_blank: 'edit',
  content: 'file-text',
  video: 'video',
}

export const EDITOR_COLORS = {
  bg: '#0a1220',
  card: '#131f2e',
  cardActive: (accent: string) => accent + '18',
  border: '#1e2d3d',
  borderActive: (accent: string) => accent + '66',
  questionText: '#ffffff',
  optionText: '#ffffff',
  placeholder: '#334155',
  muted: '#475569',
  explanation: '#94a3b8',
} as const

export const TRUE_COLOR = '#22c55e'
export const FALSE_COLOR = '#ef4444'
